import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { DataList } from "../types"

export function useList(product_id: number) {
  const api = useApi()
  const [data, setData] = useState<DataList[]>([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)

    api.get(`/product/transaction/sales/${product_id}`) 
    .then((res: SuccessFetch<{ payload: DataList[] }>) => setData(res.data.payload))
    .catch(() => setData([]) )
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }
      // eslint-disable-next-line
    }, [])

  return { data, isLoading }
}